import type { UserSummary } from '@/lib/broadcast.ts';

/**
 * What to call a recipient on screen: their name, the address when there is no
 * name, and the head of the id when the record itself is gone.
 */
export function userSummaryName(user: UserSummary): string {
  if (user.first_name || user.last_name) {
    return [user.first_name, user.last_name].filter(Boolean).join(' ');
  }
  return user.email || user.id.slice(0, 8);
}
